import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';
import App from './components/App/App';
import configureI18n from './i18n';
import { setAppConfig } from './config/config';
import { AppConfig } from './types/appConfig';
import { AppProviders } from './components/App/AppProviders';
import '@kingspan/design-system-components/fonts/light.css';
import '@kingspan/design-system-components/fonts/bold.css';
import '@kingspan/design-system-components/fonts/regular.css';
import './setup/configureDayjs';
import configureMockI18n from 'mocks/mockI18nConfig';

async function main() {
  try {
    const configData = await fetch(`${process.env.PUBLIC_URL}/config.json`);
    const appConfig = (await configData.json()) as AppConfig;

    setAppConfig(appConfig);

    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_SERVER_MOCKED === 'true') {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { worker } = require('./mocks/browser');
      worker.start();

      // When using a local mock, we can also mock out the translations but there is an issue mocking the translations request. Instead we directly use the mock json data.
      await configureMockI18n();
    } else {
      await configureI18n();
    }

    ReactDOM.render(
      <StrictMode>
        <AppProviders>
          <App />
        </AppProviders>
      </StrictMode>,
      document.getElementById('root')
    );
  } catch (error) {
    console.error('App config could not be loaded');
    console.error(error);
  }
}

main();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
